import angular from 'angular';
import { func } from 'prop-types';

angular.module('cxRelations').directive('cxRelNaceCodes', function() {
  return {
    restrict: 'E',
    template: require('./relNaceCodes.html'),
    scope: {
      field: '=',
      relation: '=',
      naceCodeString: '=data',
    },
    bindToController: true,
    controllerAs: 'vm',
    controller: [
      '$scope',
      'flySvc',
      '$http',
      'translateListFilter',
      'appUrls',
      function($scope, flySvc, $http, translateListFilter, appUrls) {
        var vm = this;

        $scope.$watch('vm.naceCodeString', () => {
          vm.naceCodes = vm.naceCodeString
            ? vm.naceCodeString
                .split(',')
                .filter(x => x !== undefined && x !== '')
                .sort()
            : [];
        });

        vm.naceCodes = vm.naceCodeString
          ? vm.naceCodeString
              .split(',')
              .filter(x => x !== undefined && x !== '')
              .sort()
          : [];
        vm.adding = false;

        vm.addNaceCode = () => {
          if (!vm.adding) {
            vm.adding = true;
          } else {
            vm.adding = false;
            vm.newNaceCode = null;
          }
        };

        vm.cancelNew = () => {
          vm.adding = false;
          vm.newNaceCode = null;
        };

        vm.submitNewNaceCode = () => {
          if (!vm.newNaceCode) return;
          vm.saving = true;
          return $http
            .post(appUrls.api + '/api/relation/nace/' + vm.relation.id + '/' + vm.newNaceCode)
            .then(
              result => {
                vm.naceCodes.push(vm.newNaceCode);
                vm.naceCodes = vm.naceCodes.sort();
                vm.saving = false;
                vm.adding = false;
                vm.newNaceCode = null;
              },
              error => {
                flySvc.error(error);
                vm.saving = false;
              },
            );
        };

        vm.delete = function(naceCode) {
          if (!naceCode) return;

          vm.deleting = true;
          return $http
            .delete(appUrls.api + '/api/relation/nace/' + vm.relation.id + '/' + naceCode)
            .then(
              result => {
                const idx = vm.naceCodes.indexOf(naceCode);
                if (idx >= 0) vm.naceCodes.splice(idx, 1);
                vm.deleting = false;
                flySvc.success();
              },
              error => {
                flySvc.error(error);
                vm.deleting = false;
              },
            );
        };
      },
    ],
  };
});
